export const CortexBindings = {
  Recognizer: 'pattern-recognizer',
  Pattern: 'pattern',
};
